// extracted by mini-css-extract-plugin
module.exports = {"container":"PossiblePatientItem_container__1HmER","icon":"PossiblePatientItem_icon__39xWd","info":"PossiblePatientItem_info__1-tDq"};